import { Alert, Backdrop, Button, Grid } from "@mui/material"
import CompMap from "../utils/CompMap"
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom"
import { fetchAnalysisSlugForAddressAsync, selectAnalysisSlug, selectAnalysisStatus, selectDomainCss } from "./AnalysisSlice"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { useEffect, useState } from "react"
import { Box } from "@mui/system"
import ErrorIcon from '@mui/icons-material/Error'

let debounceTimerAnalysis: any
const useQuery = () => new URLSearchParams(useLocation().search)

const AnalysisWip = () => {
  const navigate = useNavigate()
  const { slugOrAddress } = useParams()
  const [propertyType, setPropertyType] = useState<string>(`Single Family`)
  const dispatch = useAppDispatch()
  const [compCount, setCompCount] = useState<number>(25)
  const query = useQuery()
  const fullAddress = query.get('fullAddress')
  const [beds, setBeds] = useState(query.get('beds'))
  const [baths, setBaths] = useState(query.get('baths'))
  const [sqft, setSqft] = useState(query.get('sqft'))
  const [lat, setLat] = useState(query.get('lat'))
  const [lng, setLng] = useState(query.get('lng'))
  const slug = useAppSelector(selectAnalysisSlug)
  const analysisStatus = useAppSelector(selectAnalysisStatus)
  const domainCss = useAppSelector(selectDomainCss)

  const fetchAnalysisSlugForAddressDebounced = () => {
    if (slugOrAddress) {
      dispatch(fetchAnalysisSlugForAddressAsync({
        slugOrAddress: slugOrAddress === 'newanalysis' && fullAddress ? fullAddress : slugOrAddress,
        compCount, propertyType, beds: beds ? beds : '', lat: lat ? lat : '', lng: lng ? lng : '',
        baths: baths ? baths : '', sqft: sqft ? sqft : ''
      }))
    }
  }

  useEffect(() => {
    console.log(`slugOrAddress: ${slugOrAddress}, compCount: ${compCount}, propertyType: ${propertyType}`)
    clearTimeout(debounceTimerAnalysis)
    debounceTimerAnalysis = setTimeout(fetchAnalysisSlugForAddressDebounced, 500)
  }, [compCount, slugOrAddress, dispatch, propertyType])

  const handleCloseFault = () => { navigate(`/home`) }

  return (<Box>
    <Backdrop
      sx={{ backgroundColor: domainCss?.backdropBG, zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}>
      <img width="250" src="/images/loading.gif" />
    </Backdrop>
    {slug && <Navigate to={`/analysis/slug/${slug}`} />}
  </Box>)
}

export default AnalysisWip